import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { knopKlassen, type Nadruk } from './knopklassen.js';

export interface KnopProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  nadruk?: Nadruk;
  children: ReactNode;
}

/**
 * Eén knopcomponent voor alle apps. Minimaal 4,5rem hoog: dat is de kleinste
 * maat die je met een handschoen nog raakt. De klassen (en waarom een eigen
 * maat de standaard vervangt in plaats van erbij komt) staan in knopklassen.ts.
 */
export function Knop({ nadruk = 'gewoon', className = '', ...rest }: KnopProps) {
  return <button type="button" className={knopKlassen(nadruk, className)} {...rest} />;
}
